import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            /**
             * Init custom Slider
             * @param classNameSelectorClass
             * @param customDots
             * @param customNavigation
             */
            const initCustomSlider = (classNameSelectorClass, customDots = false, customNavigation = false) => {
                const classNameSelector = $(classNameSelectorClass);

                if(classNameSelector.length) {
                    let sliderId,
                        slider;

                    classNameSelector.each(function() {
                        sliderId = '#' + $(this).prop('id');
                        slider = $(sliderId + ' .slider__items');

                        if(customDots) {
                            slider.slick({
                                appendDots: $(sliderId + '_dots')
                            });
                        } else {
                            slider.slick();
                        }
                    });

                    if(customNavigation) {
                        initCustomSliderNavigation(classNameSelectorClass);
                    }
                }
            }

            /**
             * Init custom Navigation for Slider
             * @param className
             */
            const initCustomSliderNavigation = (className) => {
                $(className + ' .slider-prev').on('click', function() {
                    $('#' + $(this).data('slider') + ' > .slider__items').slick('slickPrev');
                });

                $(className + ' .slider-next').on('click', function() {
                    $('#' + $(this).data('slider') + ' > .slider__items').slick('slickNext');
                });
            }

            // Image-Slider
            initCustomSlider('.avency-avency-base-content-imageslider', true, true);
            initCustomSlider('.avency-avency-shared-content-imageslider', true, true);

            // Flexible Card-Slider
            initCustomSlider('.avency-avency-legacy-content-flexiblecardslider', true, true);

            // Base-Slider
            initCustomSlider('.avency-neos-baseslider-content-slider');
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
